import React, {Component} from 'react'
import {Field} from 'redux-form'
import NumberFormat from 'react-number-format'
import analytics from '@cred/react-analytics/hoc/emitOnBlur'
import './styles.scss'

/**
 * @deprecated Please use specific editors, like APR Input or Money Input.
 * @visibleName Number Editor
 */
class NumberEditor extends Component {
  render = () => <Field type="text" component={textInputWithAnalytics} {...this.props}/>
}

const textInput = field =>
  <NumberFormat
    className={field.className}
    thousandSeparator={field.thousandSeparator}
    prefix={field.prefix}
    suffix={field.suffix}
    allowNegative={field.allowNegative}
    type="text"
    placeholder={field.placeholder}
    {...field.input}
  />,
  textInputWithAnalytics = analytics(textInput)

export {NumberEditor}
